module.exports = __webpack_public_path__ + "img/ssq.964a0c78.jpg";